import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Create Sendbird Group
  [types.CREATE_SENDBIRD_GROUP_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      errors_api: {}
    };

    return { ...data };
  },

  [types.CREATE_SENDBIRD_GROUP_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload
    };

    return { ...data };
  },

  [types.CREATE_SENDBIRD_GROUP_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.CREATE_SENDBIRD_GROUP_RESET]: state => {
    const data = {
      ...state,
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

